import script from "./ConfigWhatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigWhatsapp.vue?vue&type=script&setup=true&lang=js"

import "./ConfigWhatsapp.vue?vue&type=style&index=0&id=40473a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40473a56"]])

export default __exports__